// extracted by mini-css-extract-plugin
export default {"loader_container":"dialog_loader_container__A2f9Q","lds_roller":"dialog_lds_roller__MbcqT"};